window.convertMiniBagCheckoutButton = window.convertMiniBagCheckoutButton || {};

(function (test) {
  const BUTTON_ID = 'CartDrawer-Checkout';
  const GREEN_CLASS = 'button--green';

  const applyGreen = () => {
    const btn = document.getElementById(BUTTON_ID);
    if (btn) {
      btn.classList.add(GREEN_CLASS);
      return true;
    }
    return false;
  };

  const removeGreen = () => {
    const btn = document.getElementById(BUTTON_ID);
    if (btn) btn.classList.remove(GREEN_CLASS);
  };

  const applyWithRetry = (attempts) => {
    if (applyGreen()) return;
    if (attempts > 0) setTimeout(() => applyWithRetry(attempts - 1), 100);
  };

  test.control = () => {
    removeGreen();
  };

  test.variant = () => {
    applyWithRetry(20);
  };

  test.reset = () => {
    removeGreen();
  };
})(window.convertMiniBagCheckoutButton);
